import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import React from 'react'

dayjs.extend(utc);
dayjs.extend(timezone);

const UserLogsRow: React.FC<any> = ({ log }) => {

  return (
    <tr key={log.id}>
      <td>
        {log.Date ? dayjs.utc(log.Date).tz(dayjs.tz.guess()).format('YYYY-MM-DD HH:mm:ss') : '-'}
      </td>
      <td>
        {log.Data}
      </td>
    </tr>
  )
}

export default UserLogsRow;
